export default __webpack_public_path__ + "static/media/esrp3.24d49820.svg";